import { render, staticRenderFns } from "./SearchDetail.vue?vue&type=template&id=730062c7&scoped=true&"
import script from "./SearchDetail.vue?vue&type=script&lang=ts&"
export * from "./SearchDetail.vue?vue&type=script&lang=ts&"
import style1 from "./SearchDetail.vue?vue&type=style&index=1&id=730062c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730062c7",
  null
  
)

export default component.exports